import React from 'react';
export default class Title extends React.Component {
    render() {
        const {title, subtitle} = this.props;
        return (
            <div className="m-title">
                <h1 className="main">{title}</h1>
                <p className="desc">{subtitle}</p>
            </div>
        );
    }
}
